import React, { forwardRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { Icon, Text, BoldText } from '../../atoms';

const NotificationWrapper = styled.div`
  background: rgba(0, 0, 0, 0.9);
  box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.25);
  height: 48px;
  min-width: 440px;
  box-sizing: border-box;

  border-radius: 24px;
  padding: 10px 12px;
  column-gap: 8px;

  display: inline-flex;
  align-items: center;
`;

const StyledButton = styled.button`
  margin-left: auto;
  background: none;
  border: none;
  cursor: pointer;
  color: var(--white);
  font-size: 13px;
  font-weight: 700;
  line-height: 20px;
  letter-spacing: -0.02em;
  font-family: var(--font-family-title);

  &:hover {
    text-decoration: underline;
  }
`;

const StyledText = styled(Text)`
  display: flex;
  align-items: center;

  white-space: nowrap;
`;

const Notification = forwardRef(
  (
    {
      children = null,
      className = null,
      close = null,
      closeTimeout = null,
      icon = null,
      undo = null,
      highlight = null
    },
    forwardedRef
  ) => {
    useEffect(() => {
      if (closeTimeout) {
        setTimeout(() => close(), closeTimeout);
      }
    }, []);

    return (
      <NotificationWrapper className={className} ref={forwardedRef} onClick={close}>
        {icon && <Icon name={icon} color='var(--white' />}
        <StyledText $color='var(--white)'>
          {highlight ? <BoldText text={children} boldPart={highlight} /> : children}
        </StyledText>
        {undo && <StyledButton onClick={undo}>Undo</StyledButton>}
      </NotificationWrapper>
    );
  }
);

Notification.propTypes = {
  className: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.string
  ]),
  close: PropTypes.func,
  closeTimeout: PropTypes.number,
  icon: PropTypes.string,
  undo: PropTypes.func,
  highlight: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)])
};

export { Notification };
